import { render, staticRenderFns } from "./TeamIntro.vue?vue&type=template&id=60c298c4&scoped=true&"
import script from "./TeamIntro.vue?vue&type=script&lang=ts&"
export * from "./TeamIntro.vue?vue&type=script&lang=ts&"
import style0 from "./TeamIntro.vue?vue&type=style&index=0&id=60c298c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c298c4",
  null
  
)

export default component.exports